<template>
  <div :class="{'vm-sidebar-close':sidebarCollapsed}" class="vm-sidebar">
    <el-scrollbar style="height: 100%" wrap-class="scrollbar">
      <div class="logo">
        <router-link to="/">
          <img v-if="!sidebarCollapsed" class="large" src="/img/logo_large.png">
          <img v-else class="small" src="/img/logo_small.png">
        </router-link>
      </div>
      <div class="menuSearch">
        <el-input
            v-model="menuName"
            placeholder="搜索"
            prefix-icon="el-icon-search"
            clearable
            @input="inputHandle"/>
      </div>
      <transition>
        <el-menu
            :collapse="sidebarCollapsed"
            :default-active="$route.path"
            active-text-color="#FFFFFF"

            text-color="#EEEEEE">
          <template v-for="(menu,index) in menus">
            <el-submenu
                :key="index"
                :index="index+''"
                style="border-bottom: 1px solid #171921">
              <template slot="title">
                <i
                    :class="[sidebarCollapsed?'icon-lg':sidebarCollapsed,menu.meta.icon]"
                    class="iconfont"
                    style="padding-right: 5px"/>
                <span>{{menu.meta.title}}</span>
              </template>
              <el-menu-item
                  v-for="(child,childIndex) in menu.children"
                  :key="childIndex"
                  :index="child.path"
                  @click="goto(child)">
                <i class="iconfont circle"/>
                {{child.meta.title}}
              </el-menu-item>
            </el-submenu>
          </template>
        </el-menu>
      </transition>
    </el-scrollbar>
  </div>
</template>

<script>
  import {routes} from "@/router/router";
  //import loginUtil from "@/util/loginUtil";

  export default {
    components: {},
    props: {
      sidebarCollapsed: Boolean,
    },
    data() {
      return {
        menus: [],
        menuName: "",
        menusCopy: [],
      };
    },
    mounted() {
      this.initMenu();
    },
    methods: {
      initMenu() {
        routes.forEach(item => {
          if (item.meta.type === 1) {
            item.children = (item.children || []).filter(child => {
              return this.$auth(child.meta.authIndex);
            });
            if(item.children.length > 0) {
              this.menus.push(item);
            }
          }
        });
        this.menusCopy = JSON.stringify(this.menus);
      },
      // 搜索
      inputHandle() {
        let indexs = [];
        let arr = JSON.parse(this.menusCopy);
        let newArr = [];
        if (this.menuName) {
          arr.forEach((item) => {
            if (item.children.length) {
              let result = item.children.filter((item) => item.meta.title.indexOf(this.menuName.toUpperCase()) !== -1);
              if (result.length) {
                newArr.push(item);
                item.children = result;
              }
            }
          });
          this.menus = newArr;
          if (this.menus.length) {
            this.menus.forEach((item) => {
              indexs.push(item.meta.title);
            });
            this.defaultOpens = indexs;
          }
        } else {
          this.menus = JSON.parse(this.menusCopy);
          this.defaultOpens = [];
        }
      },
      goto(menu) {
        this.$router.push({path: menu.path});
      },
    },
  };
</script>

<style lang="scss">
  @import "../../style/variables";

  .vm-sidebar {
    transition: width 0.25s ease-in-out;
    width: $sidebar-width;
    background: url("/img/leftbg.png") no-repeat top #022034 ;
    z-index: 10;

    .el-menu {
      border: none;
      background: none!important;
    }

    .icon-lg {
      font-size: 22px;
    }

    .iconfont {
      color: #ddd;
    }

    .el-menu-item {
      background-color: rgba(0, 25, 45, 0.5) !important;

      &:hover {
        background-color: #21252c !important;
      }
    }

    .is-active {
      background-color: rgba(0, 25, 45, 0.5)!important;

      &:hover {
        background-color: #21252c !important;
      }
    }
    .el-submenu  {
    &:hover {
      background-color:  rgba(0, 25, 45, 0.5) !important;
    }
    }

    .el-submenu__title{
      &:hover {
        background-color:  rgba(0, 25, 45, 0.5) !important;
      }
    }

    .logo {

      text-align: center;
      overflow: hidden;

      img {

        width: auto;
      }
    }
    .menuSearch {
      padding: 5px 20px 5px 20px;
      // border-bottom: 1px solid rgb(23, 25, 33);
      .el-input__inner {
        border-radius: 20px;
        background-color: #444;
        border: none;
        color: #fff;
      }
    }
    .scrollbar {
      height: 100vh;
      overflow-x: hidden;
    }
  }

  .vm-sidebar-close {
    width: $sidebar-width-close;
  }
</style>
